import React from 'react'
import Slider from 'react-slick'
import image from '../../assets/homepage_pro11.png'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const BestSellerProduct = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 5,
            "name": "Headphone 5",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 6,
            "name": "Headphone 6",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
    ]
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
    }
    return (
        <>
            <div className="mt-4">
                <h2 className="title1">Best Sellers Product</h2>
                <Slider {...sliderSettings}>
                    {products.map((i,index) => (
                        <div className="item" key={index}>
                            <div className="pro-bx">
                                <h4>AQUARACER</h4>
                                <h3>iPATROL RILEY - WiFi Enabled Mobilized Home Monitoring Robot</h3>
                                <div className="prod-img mt-0 p-0">
                                    <span className="tag3">New</span>
                                    <img className="img-fluid" src={image} alt="" />
                                    <a href="#" className="btn-quick">
                                        Quick View
                                    </a>
                                </div>
                                <div className="price-prt2">
                                    <h5>$245.00</h5>
                                </div>
                                <div className="f-prt">
                                    <a href="#" className="wish" data-toggle="tooltip" title="Wishlist">
                                        <i className="fa fa-heart-o" />
                                    </a>
                                    <a className="btn-cart" href="#">
                                        ADD TO CART
                                    </a>
                                    <a href="#" className="compare" data-toggle="tooltip" title="Compare">
                                        <i className="fa fa-refresh" />
                                    </a>
                                </div>
                            </div>
                        </div>))}
                </Slider>
            </div>


        </>
    )
}

export default BestSellerProduct